/**
 * Minimal footer for public site (Next.js or static).
 * No @core, no react-router – for use in platform_fe_public_node app/layout.
 * Uses only CSS variables from /config/theme.css (.platform_fe_public_config).
 */
import React from 'react';
import './PublicLayoutFooter.css';

const currentYear = new Date().getFullYear();

const PublicLayoutFooter = () => (
  <footer className="public-layout-footer" role="contentinfo">
    <div className="public-layout-footer__inner">
      <div className="public-layout-footer__links">
        <a href="/legal/terms">Terms</a>
        <a href="/privacy">Privacy</a>
        <a href="/impressum">Impressum</a>
      </div>
      <div className="public-layout-footer__copy">
        &copy; {currentYear} B-esper. All rights reserved.
      </div>
    </div>
  </footer>
);

export default PublicLayoutFooter;
